import { SUPPORTED_GOOGLE_DRIVE_MIME_TYPES } from './memory';

/** Chat parsing supports binary Excel without broadening memory ingestion. */
export const CHAT_FILE_ACCESS_MIME_TYPES: readonly string[] = [
  ...SUPPORTED_GOOGLE_DRIVE_MIME_TYPES,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
